import React, {useState, useRef, useEffect} from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import logo from './Images/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import SideNav from './SideNav';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import Navigation from './Navigation';
import CreatePostModal from './modals/CreatePostModal';
import userimage from './Images/user.png';
import {connect} from 'react-redux';
import { FaPlus } from 'react-icons/fa';
import { Bounce } from 'react-activity';
import { notification } from 'antd';
import { SmileOutlined, FrownOutlined } from '@ant-design/icons';
import {logOut} from './redux/actions';




const UserSettings = ({currentUser}) => {
    const navigate = useNavigate();
    const myElementRef = useRef();
    const[showDropdownPage, setShowDropdownPage] = useState(false); 
    const[navHeight, setNavHeight] = useState(0);
    const[isLoggedIn, setIsLoggedIn] = useState(false);
    const[isCreatePostModalVisible, setIsCreatePostModalVisible] = useState(false);
    const[isUploading, setIsUploading] = useState(false);
    

    const[name, setName] = useState('');
    const[userName, setUsername] = useState('');
    const[dob, setDob] = useState('');
    const[role, setRole] = useState('');

    const[currentPassword, setCurrentPassword] = useState('')
    const[password, setPassword] = useState('');
    const[confirmPassword, setConfirmPassword] = useState('');

    const[location, setLocation] = useState('');

    const[image, setImage] = useState(null);
    const[imageUrl, setImageUrl] = useState(null);
    const[fileType, setFileType] = useState('');
    const [fileName, setFileName] = useState('');

    const[loginMethod, setLoginMethod] = useState('');

    const onLogOut = () => {
        firebase.auth().signOut();
        firebase.auth().signOut();
        logOut();
      }


    const fileInputRef = useRef(null)

    const[text, setText] = useState('')

    const handleTextChange = (event) => {
        setText(event.target.value)
    }

    const handleButtonClick = () => {
        fileInputRef.current.click();
    }
    const handleFileChange = (event) => {
        if (event.target.files[0]) {
          const selectedImage = event.target.files[0]
          const fileType = selectedImage.name.split('.').pop().toLowerCase();
          setFileType(fileType);
          setImage(selectedImage);
          setImageUrl(URL.createObjectURL(selectedImage));
          setFileName(selectedImage.name);
        }
    }

    useEffect(() => {
        const element = myElementRef.current;
        const height = element.offsetHeight;
        setNavHeight(height);
        if (showDropdownPage === true) {
            document.querySelector('.settings-body').classList.add('no-scroll');
        } else {
            document.querySelector('.settings-body').classList.remove('no-scroll');
        }
        if(isUploading) {
            document.querySelector('.settings-main-div').classList.add('no-scroll');
        } else {
            document.querySelector('.settings-main-div').classList.remove('no-scroll');
        }
        firebase.auth().onAuthStateChanged((user) => {
            if(!user){
              setIsLoggedIn(false)
              window.location ='/'
            } else {
              setIsLoggedIn(true)
                var userCredential = user.providerData[0]; // Get the first provider's data
                var providerId = userCredential.providerId;

                if (providerId === 'password') {
                    // User logged in using email/password authentication
                    setLoginMethod('emailandpassword')
                } else if (providerId === 'google.com') {
                    // User logged in using Google authentication
                    setLoginMethod('google')
                }
            }
        })
    }, [showDropdownPage, isUploading])

    const handleNameChange = (event) => {
        setName(event.target.value);
    };
    const handleUsernameChange = (event) => {
        setUsername(event.target.value)
    }
    const handleRoleChange = (event) => {
        setRole(event.target.value);
    };
    const handleCurrentPasswordChange = (event) => {
        setCurrentPassword(event.target.value)
    }
    const handlePasswordChange = (event) => {
        setPassword(event.target.value)
    }
    const handleConfirmPasswordChange = (event) => {
        setConfirmPassword(event.target.value)
    }
    const handleDobChange = (event) => {
        setDob(event.target.value)
    }
    const handleLocationChange = (event) => {
        setLocation(event.target.value)
    }
    
    const userRef = firebase.firestore().collection('users').doc(firebase.auth().currentUser.uid);

    const updatePosterNames = async () => {
        const userPostsRef = firebase
          .firestore()
          .collection('posts')
          .doc(firebase.auth().currentUser.uid)
          .collection('userPosts');
      
        const querySnapshot = await userPostsRef.get();
      
        const batch = firebase.firestore().batch();
      
        querySnapshot.forEach((doc) => {
          const docRef = userPostsRef.doc(doc.id);
          batch.update(docRef, { posterName: name });
        });
      
        await batch.commit();
      
        console.log('Poster names updated successfully.');
    };

    const updateName = (event) => {
        setIsUploading(true)
        userRef
        .update({
            name: name
        })
        .then(() => {
            //console.log('Updated successful')
            setIsUploading(false)
            updatePosterNames()
        }).catch((error) => {
            console.log(error)
        })
        event.preventDefault();
    }
    const updateUsername = (event) => {
        setIsUploading(true)
        userRef
        .update({
            username: userName
        })
        .then(() => {
            //console.log('Updated successful')
            setIsUploading(false)
        }).catch((error) => {
            console.log(error)
        })
        event.preventDefault();
    }

    const openSuccessNotification = (message) => {
        notification.open({
          message: `${message}`,
          duration: 2,
          icon: <SmileOutlined style={{ color: '#71b324' }} />,
        });
    };
    
    const openErrorNotification = (message, error) => {
        notification.open({
          message: `${message}`,
          description: `${error}`,
          duration: 11,
          icon: <FrownOutlined style={{ color: 'red' }} />
      
        });
    };

    const updatePassword = (event) => {
        if (confirmPassword === password) {
            setIsUploading(true)
            var user = firebase.auth().currentUser;
            var newPassword = password;
            var credential = firebase.auth.EmailAuthProvider.credential(user.email, currentPassword);

            user.reauthenticateWithCredential(credential)
            .then(function() {
                user.updatePassword(newPassword)
                .then(function() {
                    setIsUploading(false)
                    openSuccessNotification("Password updated successfully");
                })
                .catch(function(error) {
                    setIsUploading(false)
                    openErrorNotification("Error updating password", error);
                });
            })
            .catch(function(error) {
                openErrorNotification("Error reauthenticating user: ", error);
                setIsUploading(false)
            });
        }
        event.preventDefault();
    }
    const updateLocation = (event) => {
        setIsUploading(true)
        userRef
        .update({
            location: location
        })
        .then(() => {
            //console.log('Updated successful')
            setIsUploading(false)
        }).catch((error) => {
            console.log(error)
        })
        event.preventDefault();
    }
    const updateRole = (event) => {
        setIsUploading(true)
        userRef
        .update({
            role: role
        })
        .then(() => {
            //console.log('Updated successful')
            setIsUploading(false)
        }).catch((error) => {
            console.log(error)
        })
        event.preventDefault();
    }
    const updateDob = (event) => {
        setIsUploading(true)
        userRef
        .update({
            dob: dob
        })
        .then(() => {
            //console.log('Updated successful')
            setIsUploading(false)
        }).catch((error) => {
            console.log(error)
        })
        event.preventDefault();
    }

    const handleUpload = async () => {
        setIsUploading(true)
        const uploadTask = firebase.storage().ref(`/images/${image.name}`).put(image)
        uploadTask.on('state_changed', 
        (snapShot) => {
          console.log(snapShot)
        }, (err) => {
          console.log(err)
        }, async () => {
          firebase.storage().ref('images').child(image.name).getDownloadURL()
           .then(fireBaseUrl => {
              savePostData(fireBaseUrl)
           })
        })
    
      }
      const savePostData = (downloadURL) => {
        userRef
        .update({
            image: downloadURL
        })
        .then(() => {
            //console.log('Updated successful')
            setIsUploading(false)
            window.location = '/account/settings'
        }).catch((error) => {
            console.log(error)
        })
    }
    const search = (event) => {
        navigate('/search', {state:{text: text}});
        event.preventDefault()
      }
  return (
    <div className='settings-main-div'>
        <div>
            <Navbar bg="" expand="lg" className="navbar feed-navbar" ref={myElementRef}>
                <Container fluid className="header">
                    <Navbar.Brand href="/" className="logo"><img src={logo} alt="Cuisn Logo" className="logo"></img></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" className="toggle-button" onClick={() => {if (window.innerWidth <= 991) {setShowDropdownPage(!showDropdownPage)}}}/>
                    <Navbar.Collapse id="basic-navbar-nav" className='basic-navbar-nav'>
                        <div className='mr-auto'>
                            <div className='header-input-inner-div'>
                                <form onSubmit={search}>
                                    <Row>
                                        <Col xs={12} sm={12} md={9} lg={9}>
                                            <input placeholder='Tacos, Chef Lanez, Bistros, Culinary School, Utensils' className='header-input header-type-input top-nav-input' value={text} onChange={handleTextChange}></input>
                                        </Col>
                                        <Col xs={12} sm={12} md={3} lg={3}>
                                            <button className='header-search-button nav-search-button' type='submit' name='submit'>Search</button>
                                        </Col>
                                    </Row>
                                </form>
                            </div>
                        </div>
                        <Nav className="ms-auto">
                            <div>
                                <Link to='/profile'>{(currentUser.image === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={currentUser.image} alt=''className='feed-card-user-image'></img>}</Link>
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
        <div className='settings-body'>
            <Container>
                <Row>
                    <Col lg={4} md={3} sm={0} xs={0}>
                        <div className='settings-side-tab'>
                            <button className='account-action-button'>Account</button>
                            {isLoggedIn ? <p><Link to='/' onClick={() => onLogOut()} className='log-out-link'>Log Out</Link></p> : null}
                        </div>
                    </Col>
                    <Col lg={8} md={9} sm={12} xs={12}>
                        <div className='settings-info-tab'>
                            <h4>Account</h4>

                            <Row className='settings-action-row'>
                                <Col xs={6} sm={6} md={3} lg={3} className=''>
                                    <button className='edit-profile-image-trigger-button remove-left-right-padding' onClick={handleButtonClick}>
                                        <div className='profile-image-edit' style={{backgroundImage: `url('${(currentUser.image === '') ? userimage : image ? imageUrl : currentUser.image}')`}}>
                                            <div className='profile-image-edit-inner'>
                                                <FaPlus style={{color: 'white', height: '24px', width: '24px'}}/>
                                            </div>
                                        </div>
                                    </button>
                                        <input type='file' ref={fileInputRef} style={{display: 'none'}} onChange={handleFileChange} accept="image/*, image/png, image/jpg, image/jpeg, image/svg"></input>
                                </Col>
                                <Col xs={0} sm={0} md={6} lg={6} className='edit-profile-col-display-none'>
                                    <div style={{width: '100%'}}></div>
                                </Col>
                                <Col xs={6} sm={6} md={3} lg={3}>
                                    <div className='edit-profile-image-button-div'>
                                        {image ? 
                                            <button type='submit' name='submit' value='submit' className='account-settings-save-button save-image-button' onClick={handleUpload}>Save</button> :
                                            <button className='account-settings-save-button save-image-button' disabled>Save</button> 
                                        }  
                                    </div> 
                                </Col>
                            </Row>

                            <form onSubmit={updateName}>
                                <Row style={{marginTop: '30px'}}>
                                    <Col xs={12} sm={12} md={3} lg={3}>
                                        <p><label htmlFor='name'>Name:</label></p>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <input name='name' id='name' placeholder='Name' value={name} onChange={handleNameChange}></input>
                                    </Col>
                                    <Col xs={12} sm={12} md={3} lg={3}>
                                        {name === '' ? 
                                            <button className='account-settings-save-button' disabled>Save</button> : 
                                            <button type='submit' name='submit' value='submit' className='account-settings-save-button'>Save</button>
                                        }  
                                    </Col>
                                </Row>
                            </form>

                            <form onSubmit={updateUsername}>
                                <Row className='settings-action-row'>
                                    <Col xs={12} sm={12} md={3} lg={3}>
                                        <p><label htmlFor='username'>Username:</label></p>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <input name='username' id='username' placeholder='Username' value={userName} onChange={handleUsernameChange}></input>
                                    </Col>
                                    <Col xs={12} sm={12} md={3} lg={3}>
                                        {userName === '' ? 
                                            <button className='account-settings-save-button' disabled>Save</button> : 
                                            <button type='submit' name='submit' value='submit' className='account-settings-save-button'>Save</button>
                                        }  
                                    </Col>
                                </Row>
                            </form>

                                {(loginMethod === 'google') ? null : (loginMethod === 'emailandpassword') ? 
                                    <form onSubmit={updatePassword}>
                                        <Row className='settings-action-row'>
                                            <Col xs={12} sm={12} md={3} lg={3}>
                                                <p>Change Password</p>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6}>
                                                <input placeholder='Current Password' value={currentPassword} onChange={handleCurrentPasswordChange}></input>
                                                <input placeholder='Password' value={password} onChange={handlePasswordChange}></input>
                                                <input placeholder='Confirm password' value={confirmPassword} onChange={handleConfirmPasswordChange} style={{marginTop: '10px'}}></input>
                                                {(confirmPassword === '') ? null: (confirmPassword !== password) ? <span className='passwords-not-match'>Passwords don't match</span> : null}
                                            </Col>
                                            <Col xs={12} sm={12} md={3} lg={3}>
                                                {(password === '' && confirmPassword === '') ? 
                                                    <button className='account-settings-save-button' disabled>Save</button> : 
                                                    <button type='submit' name='submit' value='submit' className='account-settings-save-button'>Save</button>
                                                }  
                                            </Col>
                                        </Row>
                                    </form> : null
                                }

                                <form onSubmit={updateLocation}>
                                    <Row className='settings-action-row'>
                                        <Col xs={12} sm={12} md={3} lg={3}>
                                            <p><label htmlFor='location'>Location:</label></p>
                                        </Col>
                                        <Col xs={12} sm={12} md={6} lg={6}>
                                            <input name='location' id='location' placeholder='Location' value={location} onChange={handleLocationChange}></input>
                                        </Col>
                                        <Col xs={12} sm={12} md={3} lg={3}>
                                            {location === '' ? 
                                                <button className='account-settings-save-button' disabled>Save</button> : 
                                                <button type='submit' name='submit' value='submit' className='account-settings-save-button'>Save</button>
                                            }  
                                        </Col>
                                    </Row>
                                </form>

                                <form onSubmit={updateRole}>
                                    <Row className='settings-action-row'>
                                        <Col xs={12} sm={12} md={3} lg={3}>
                                            <p><label htmlFor='role'>Role:</label></p>
                                        </Col>
                                        <Col xs={12} sm={12} md={6} lg={6}>
                                            <select name='role' id='role' className='waitlist-modal-input role-select-setting' value={role} onChange={handleRoleChange}>
                                            <option value="">Select an item...</option>
                                                    <option value='foodie'>I'm a foodie</option>
                                                    <option value='chef'>I'm a chef</option>
                                                    <option value='restaurant'>I'm a restaurant</option>
                                                    <option value='food-blogger'>I'm a food blogger</option>
                                                    <option value='food-content-creator'>I'm a food content creator</option>
                                                    <option value='food-items-vendor'>I'm a food items vendor</option>
                                            </select>
                                            <p className='settings-more-info-texts'>Choose the one that best suits what you do. Your role determines what you see and what you can do. Read more in <a href='#' className='settings-read-more-link'>Terms of Service</a></p>
                                        </Col>
                                        <Col xs={12} sm={12} md={3} lg={3}>
                                            {role === '' ? 
                                                <button className='account-settings-save-button' disabled>Save</button> : 
                                                <button type='submit' name='submit' value='submit' className='account-settings-save-button'>Save</button>
                                            }  
                                        </Col>
                                    </Row>
                                </form>

                                <form onSubmit={updateDob}>
                                    <Row className='settings-action-row'>
                                        <Col xs={12} sm={12} md={3} lg={3}>
                                            <p><label htmlFor='dob'>D.O.B:</label></p>
                                        </Col>
                                        <Col xs={12} sm={12} md={6} lg={6}>
                                            <input name='dob' id='dob' type='date' value={dob} onChange={handleDobChange}></input>
                                            <p className='settings-more-info-texts'>Some content's visibility might be subject to age restriction. We will not share your Birthday with other users. Read more in <a href='#' className='settings-read-more-link'>Terms of Service</a></p>
                                        </Col>
                                        <Col xs={12} sm={12} md={3} lg={3}>
                                            {dob === '' ? 
                                                <button className='account-settings-save-button' disabled>Save</button> : 
                                                <button type='submit' name='submit' value='submit' className='account-settings-save-button'>Save</button>
                                            }  
                                        </Col>
                                    </Row>
                                </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
        <div className={`feed-side-nav ${showDropdownPage ? 'slide-in' : ''}`} style={{top: `${navHeight}px`}}>
            <SideNav isLoggedIn={isLoggedIn}/>
        </div>
        <Navigation setIsCreatePostModalVisible={setIsCreatePostModalVisible} isCreatePostModalVisible={isCreatePostModalVisible} isLoggedIn={isLoggedIn}></Navigation>
        <CreatePostModal isCreatePostModalVisible={isCreatePostModalVisible} setIsCreatePostModalVisible={setIsCreatePostModalVisible}></CreatePostModal>
        {isUploading && <div className='loader'><Bounce className='bounce'/></div>}
    </div>
  )
}
const mapStateToProps = (state) => ({
    currentUser: state.currentUser
})
export default connect(mapStateToProps, null)(UserSettings)